const config = {
  development: {
    apiUrl: "http://localhost:4003/java/",
    localUrl: "http://localhost:3000",
    pythonUrl: "http://127.0.0.1:5000/python/",
    
  },
  prodbuild: {
    apiUrl: "https://dashboard.saddlepointtech.com/java/",
    localUrl: "https://dashboard.saddlepointtech.com/",
    pythonUrl: "https://dashboard.saddlepointtech.com/python/", 
      

  },
  testbuild: {
    apiUrl: "https://dashboardtest.saddlepointtech.com/java/", 
    localUrl: "https://dashboardtest.saddlepointtech.com/",
    pythonUrl: "https://dashboardtest.saddlepointtech.com/python/",

  },
  test2build: {    
    apiUrl: "https://dashboardtest2.saddlepointtech.com/java/", 
    localUrl: "https://dashboardtest2.saddlepointtech.com/",
    pythonUrl: "https://dashboardtest2.saddlepointtech.com/python/",

  },
  scptestbuild: {
    apiUrl: "https://scptestdashboard.saddlepointtech.com/java/", 
    localUrl: "https://scptestdashboard.saddlepointtech.com/",
    pythonUrl: "https://scptestdashboard.saddlepointtech.com/python/",
  },
  scptestazurebuild: {
    apiUrl: "https://dashboardscptestazure.saddlepointtech.com/java/", 
    localUrl: "https://dashboardscptestazure.saddlepointtech.com/",
    pythonUrl: "https://dashboardscptestazure.saddlepointtech.com/python/",

  },
  demobuild: {
    apiUrl: "https://demodashboard.saddlepointtech.com/java/",
    localUrl: "https://demodashboard.saddlepointtech.com/",
    pythonUrl: "https://demodashboard.saddlepointtech.com/python/",

  },
  vgilprodbuild: {
    apiUrl: "https://saddlepointdash.vguard.in/java/",
    localUrl: "https://saddlepointdash.vguard.in/",
    pythonUrl: "https://saddlepointdash.vguard.in/python/",

  },
  vgildevbuild: {
    apiUrl: "https://saddlepointdash-dev.vguard.in/java/",
    localUrl: "https://saddlepointdash-dev.vguard.in/",
    pythonUrl: "https://saddlepointdash-dev.vguard.in/python/",

  },

};


export default config;
